import { render, staticRenderFns } from "./BookingZonesSummary.vue?vue&type=template&id=5f1214f6&scoped=true&"
import script from "./BookingZonesSummary.vue?vue&type=script&lang=js&"
export * from "./BookingZonesSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingZonesSummary.vue?vue&type=style&index=0&id=5f1214f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1214f6",
  null
  
)

export default component.exports